<template>
  <div class="container">
    <div class="jumbotron">
      <h1 class="company-title">
        Rent Application
      </h1>
      <h1>
        {{
          getVerification && getVerification.type.includes("landlord")
            ? "Residence"
            : "Employment"
        }}
        Verification for
        {{ getVerification.request_data.applicant_first_name }}
        {{ getVerification.request_data.applicant_last_name }}
      </h1>
      <div class="device-container">
        <img style="width: 170px;" src="@/assets/device.png" />
      </div>
    </div>
    <div class="line" style="width: 90%;"></div>
    <div v-if="!isLoading">
      <div class="who" style="padding: 10px 5vw;">
        <div class="logo-container" style="display: flex;">
          <div>
            <img src="@/assets/logo.png" style="width: 58px; height: 58px;" />
          </div>
          <div style="margin-left: 20px;">
            <h2>
              Who is Rent Application?
            </h2>
          </div>
        </div>
        <div>
          <p style="margin: 20px 0px;">
            Rent Application, a participating member of the National Consumer
            Reporting Association, is an online tenant screening platform that
            has been serving more than 40,000 landlords and real estate
            professionals nationwide since 2013. Rent Application is trusted by
            the real estate industry’s biggest names:
          </p>
        </div>
      </div>
      <div style="padding: 10px;">
        <img style="max-width: none;" src="@/assets/logo-banner.png" />
      </div>

      <div
        v-if="getVerification.auth_data && getVerification.auth_data.signature"
        style="padding: 20px 5vw;"
      >
        <signature />
      </div>
      <div style="padding: 10px 10vw;">
        <p>
          Thank you in advance for your assistance. If you are not able to
          complete the verification, or if you have questions, please contact
          me.
        </p>
        <p style="margin-top: 20px;">
          Jake L.
          <br />Rent Application <br />(855) 949-9988
          <br />verifications@rentapplication.net
          <br />
        </p>
      </div>
      <div class="line" style="width: 90vw;"></div>
    </div>
    <div class="button-container" style="padding: 30px; margin-bottom: 30px;">
      <router-link
        tag="a"
        :to="{ name: 'verify-section2', params: { verifyType: getVerifyType } }"
        >Next</router-link
      >
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import signature from "@/components/Signature.vue";

export default {
  components: {
    signature
  },
  computed: {
    ...mapGetters(["getVerification", "isLoading", "getVerifyType"])
  }
};
</script>
<style lang="scss" scoped>
.jumbotron {
  height: 600px;
  padding: 20px;
  background: linear-gradient(165deg, transparent 50%, #fff 50.1%),
    linear-gradient(to bottom, #3659c0, #3659c0);

  h1 {
    font-family: Helvetica Neue;
    color: white;
    font-style: normal;
    font-weight: normal;
    font-size: 52px;
    line-height: 80px;
    /* or 154% */

    text-align: center;
    margin: 0px;
  }
  .company-title {
    font-weight: 300;
  }
  .device-container {
    text-align: center;
    margin-top: 20px;
  }
}

h2 {
  font-weight: normal;
  font-size: 45px;
  line-height: 64px;
  margin: 0px;
}
p {
  max-width: none;
  margin: 0px;
  padding: 0px;
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  font-family: Helvetica Neue;
}

img {
  width: 100%;
  max-width: 700px;
}
.button-container {
  align-items: center;
  display: flex;
  justify-content: center;
  a {
    display: block;
    width: 150px;
    padding: 10px 0;
    border: 2px solid #3ec19d;
    background: #3ec19d;
    border-radius: 2px;
    text-decoration: none;
    font-size: 16px;
    color: #fff;
    text-align: center;
    font-weight: 600;
  }
}

@media (max-width: 768px) {
  .jumbotron {
    h1 {
      font-size: 32px;
      line-height: 50px;
    }
  }
  h2 {
    font-size: 32px;
    line-height: 32px;
  }
  p {
    font-size: 16px;
  }
}
</style>
